/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbIconConfig,
  NbToastrService,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "./@core/data/users";
import { UserService } from "./@core/services/user.service";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { SeoService } from "./@core/utils/seo.service";
import Announcement from "./models/announcement.model";
import { AnnouncementService } from "./services/announcement.service";
import { CustomerService } from "./services/customer.service";
import { ProductService } from "./services/product.service";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  private destroy$: Subject<void> = new Subject<void>();
  uid = "";
  shopId = "";
  user?: User;

  constructor(
    private userService: UserService,
    private announcementService: AnnouncementService,
    private analytics: AnalyticsService,
    private seoService: SeoService,
    public productService: ProductService,
    private customerService: CustomerService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.initUser();
    //this.getHomeAnnouncements();
  }

  initUser() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId;

          let isInit = !this.user.offlineDb;
          this.productService.initIndexedDbProducts(user.shopId, isInit);
          this.customerService.initIndexedDbCustomers(user.shopId, isInit);
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
        }
      });
  }

  private getHomeAnnouncements(): void {
    this.announcementService
      .getHomeAnnouncements()
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        console.log("getHomeAnnouncements:", data);
        if (data.length > 0) {
          const announcement: Announcement = data[0];
          const type: any = announcement.priority
            ? announcement.priority
            : "primary";

          this.showToast(type, announcement.title, announcement.description);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    this.productService.destroy$.next();
    this.productService.destroy$.complete();

    this.customerService.destroy$.next();
    this.customerService.destroy$.complete();
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const iconConfig: NbIconConfig = { icon: "email-outline", pack: "eva" };
    const config = {
      status: type,
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      iconConfig: iconConfig,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
